module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_Kulchur3_1961_p20.f253e8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_Kulchur3_1961_p20.jpg
// module id = ZCRC
// module chunks = 0